import React, { useEffect, useState } from 'react';
import SlideToggle from '../../../../../../../../common/components/ui/toggleSwitch/SlideToggle';
import { formatCurrency } from '../../../../../../../../common/helpers/mask.helpers';
// import InputFormik from '../../../../../../../../common/components/form/InputFormik';
import InputMoney from '../../../../../../../../common/components/form/CurrencyInputFormik';

interface AditionalValuesCancelPlanProps {
  valueWeeks: number; // Valor da semana, por exemplo "R$ 200,00"
  dailyFine: number; // Valor da multa diária
  finePlanValue: string; // Valor da multa do plano
  onTotalChange?: (values: {
    initalValue: number;
    amountValue: number;
    isCheckedRetraction: boolean;
    isCheckedCommandBlock: boolean;
    valuesSinister: number;
    isPostWeekChecked: boolean;
  }) => void;
}

const AditionalValuesCancelPlan: React.FC<AditionalValuesCancelPlanProps> = ({ valueWeeks, finePlanValue, onTotalChange }) => {
  const [isPostWeekChecked, setPostWeekChecked] = useState(false);
  const [isCheckedSinister, setCheckedSinister] = useState(false);
  const [valueSinister, setValueSinister] = useState(0);
  const [isCheckedRetraction, setCheckedRetraction] = useState(false);
  const [isCheckedCommandBlock, setCheckedCommandBlock] = useState(false);

  let initalValue = parseFloat(finePlanValue);




  const additionalValuePostWeek = isPostWeekChecked
    ? valueWeeks
    : 0;

  const additionalValueSinister = isCheckedSinister ? valueSinister : 0;

  const additionalFine = isCheckedRetraction ? 200 : 0;
  const additionalValueCommandBlock = isCheckedCommandBlock ? 20 : 0;


  const amountValue = additionalValuePostWeek + additionalFine + additionalValueCommandBlock + additionalValueSinister;

  if (amountValue > 0) {

    initalValue += amountValue;
  }


  // Sempre que o valor total mudar, chame onTotalChange (se fornecido)
  useEffect(() => {
    if (onTotalChange) {
      onTotalChange({ initalValue, amountValue, isCheckedRetraction, isCheckedCommandBlock, valuesSinister: valueSinister, isPostWeekChecked });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPostWeekChecked, isCheckedCommandBlock, isCheckedRetraction, isCheckedSinister, initalValue, amountValue]);
  return (
    <section>
      <div className=" mt-2 pb-3 flex items-center">
        <label className="font-semibold text-[14px]">Semana Pós?</label>
        <SlideToggle
          name="isPostWeekChecked"
          className="ml-2"
          onToggle={(checked) => setPostWeekChecked(checked)}
        />
        <span className="ml-2">{isPostWeekChecked ? "Sim" : "Não"}</span>
      </div>

      <div className="pb-3 flex items-center">
        <label className="font-semibold text-[14px]">Multa por bloqueio?</label>
        <SlideToggle
          name="isCheckedCommandBlock"
          className="ml-2"
          onToggle={(checked) => setCheckedCommandBlock(checked)}
        />
        <span className="ml-2">{isCheckedCommandBlock ? "Sim" : "Não"}</span>
      </div>

      <div className="pb-3 flex items-center">
        <label className="font-semibold text-[14px]">Multa por recolhimento?</label>
        <SlideToggle
          name="isCheckedRetraction"
          className="ml-2"
          onToggle={(checked) => setCheckedRetraction(checked)}
        />
        <span className="ml-2">{isCheckedRetraction ? "Sim" : "Não"}</span>
      </div>

      <div className="pb-3" style={{ display: 'flex', alignItems: 'center' }}>
        <label className="font-semibold text-[14px]"> Danificação do veículo? </label>
        <SlideToggle
          name="isCheckedSinister"
          className="ml-2"
          onToggle={(checked) => {
            setCheckedSinister(checked);
          }}
        />
        <span style={{ marginLeft: '10px' }}>{isCheckedSinister ? "Sim" : "Não"}</span>
      </div>
      {isCheckedSinister && (
        <div>
          {/* <InputFormik
            required={true}
            label="Digite o valor do sinistro para adicionar a multa"
            name="sinister"
            type="text"
            mask={maskCurrency} // Sua função de máscara que formata para exibir "R$ 1.522,46"
            value={valueSinister}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              // Remove tudo que não for dígito
              const cleaned = e.target.value.replace(/[^\d]/g, '');

              // Converte para número e divide por 100 para considerar os centavos
              const numericValue = parseFloat(cleaned) / 100;

              // Atualiza o estado com o valor numérico
              setValueSinister(isNaN(numericValue) ? 0 : numericValue);
            }}
          /> */}
          <InputMoney
            label="Digite o valor do sinistro para adicionar a multa"
            name="sinister"
            required={true}
            value={valueSinister}
            onValueChange={(newValue) => setValueSinister(newValue)}
          />

        </div>
      )}

      <div className="mt-4">
        <p className="text-redPrimary text-sm">
          Valor total calculado: R$ {formatCurrency(initalValue)}
        </p>
      </div>
    </section>
  );
};

export default AditionalValuesCancelPlan;
